import { render } from "./ReportWithParams.vue?vue&type=template&id=627e1f25&scoped=true"
import script from "./ReportWithParams.vue?vue&type=script&lang=js"
export * from "./ReportWithParams.vue?vue&type=script&lang=js"

import "./ReportWithParams.vue?vue&type=style&index=0&id=627e1f25&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627e1f25"]])

export default __exports__